module.exports = __webpack_public_path__ + "static/media/aws.8d3a04e9.svg";